const RECOVERY_PENDING_KEY = 'clinic_ms_recovery_session_pending'

/** Recovery links create a real session; flag until password is updated or user signs out. */
export function markRecoverySessionPending(): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(RECOVERY_PENDING_KEY, '1')
}

export function clearRecoverySessionPending(): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(RECOVERY_PENDING_KEY)
}

export function isRecoverySessionPending(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(RECOVERY_PENDING_KEY) === '1'
}

const RECOVERY_ALLOWED_PREFIXES = ['/reset-password', '/auth', '/login', '/forgot-password'] as const

export function isRecoveryAllowedPath(pathname: string): boolean {
  return RECOVERY_ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}

/** Redirect recovery sessions away from the app shell until password is set. */
export function redirectRecoverySessionIfNeeded(pathname: string): boolean {
  if (!isRecoverySessionPending()) return false
  if (isRecoveryAllowedPath(pathname)) return false
  window.location.replace('/reset-password')
  return true
}
